import React from "react";

export default function ColorFrame35({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <g clipPath="url(#clip0_2257_162497)">
          <path
            fill="#A47AD9"
            d="M120.132 189.187a13.891 13.891 0 0111.128-7.458l19.284-1.687a13.894 13.894 0 0114.046 8.523l28.431 68.628c3.79 9.147-2.933 19.21-12.834 19.21h-82.34c-10.411 0-17.123-11.029-12.34-20.276l34.625-66.94z"
          ></path>
          <rect
            width="276"
            height="239.879"
            y="9"
            fill="#8859C2"
            rx="27.785"
          ></rect>
          <rect
            width="240.805"
            height="194.497"
            x="17.597"
            y="27.523"
            fill="#FCF7FF"
            rx="18.523"
          ></rect>
          <circle cx="242.195" cy="238.228" r="3.242" fill="#FFC444"></circle>
          <circle cx="232.007" cy="238.228" r="2.315" fill="#FFC444"></circle>
          <circle cx="222.745" cy="238.228" r="2.315" fill="#FFC444"></circle>
          <rect
            width="174"
            height="164"
            x="51"
            y="43"
            fill="#EBCBFB"
            rx="8"
          ></rect>
          <path
            fill="#B150D2"
            d="M51 51a8 8 0 018-8h158a8 8 0 018 8v4H51v-4z"
          ></path>
          <path
            stroke="#fff"
            strokeLinecap="round"
            d="M213 47.342l4 3.721M217 47.342l-4 3.721"
          ></path>
          <rect
            width="4"
            height="3"
            x="203.5"
            y="47.5"
            stroke="#fff"
            rx="0.5"
          ></rect>
          <path stroke="#fff" strokeLinecap="round" d="M198 51h-4"></path>
        </g>
        <defs>
          <clipPath id="clip0_2257_162497">
            <path fill="#fff" d="M0 0H276V276H0z"></path>
          </clipPath>
        </defs>
        {children}
      </g>
    </svg>
  );
}
